import type from '../commons/scheduleActionStatus';

const DEFAULT_STATE = {
    events: [],
    error: null,
    requestState: false,
    status: null,
    eventCreated: {},
    eventUpdated: {},
    eventDeleted: {},
    slotSummary: [],
    updateSlot: {},
    blockSlot: {},
    unavailability: [],
    unavailabilityCreated: {},
    unavailabilityDeleted: {},
    availability: [],
    availabilityCreated: {},
    availabilityUpdated: {},
    bulk:{}, 
    unblock:{}, 
    cancelBulkAppointment:{},
    timeline:[]
};

export const scheduleReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    let eventCreated;
    let eventUpdated;
    let eventDeleted;
    let unavailabilityCreated;
    let unavailabilityDeleted;
    let availabilityCreated;

    switch (actionType) {

        case type.GET_EVENTS_REQUEST:
            return { ...state, events: [], requestState, status };

        case type.GET_EVENTS_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                events: action.result,
            };

        case type.GET_EVENTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.POST_EVENTS_REQUEST:
            return { ...state, requestState, status };

        case type.POST_EVENTS_SUCCESS:
            eventCreated = action.result;
            return {
                ...state,
                eventCreated,
                requestState,
                status,
            };

        case type.POST_EVENTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.UPDATE_EVENTS_REQUEST:
            return { ...state, eventUpdated: {}, requestState, status };

        case type.UPDATE_EVENTS_SUCCESS:
            eventUpdated = action.result;
            return {
                ...state,
                eventUpdated,
                requestState,
                status,
            };

        case type.UPDATE_EVENTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.DELETE_EVENTS_REQUEST:
            return { ...state, requestState, status };

        case type.DELETE_EVENTS_SUCCESS:
            eventDeleted = action.result;
            return {
                ...state,
                eventDeleted,
                requestState,
                status,
            };

        case type.DELETE_EVENTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_SLOT_SUMMARY_REQUEST:
            return { ...state, requestState, status };
            // return { ...state, slotSummary: [],blockSlot:{}, requestState, status };

        case type.GET_SLOT_SUMMARY_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                slotSummary: action.result,
            };

        case type.GET_SLOT_SUMMARY_FAILURE:
            return { ...state, error, requestState, status };

        case type.UPDATE_SLOT_SUMMARY__REQUEST:
            return { ...state, updateSlot: {}, requestState, status };

        case type.UPDATE_SLOT_SUMMARY__SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                updateSlot: action.result,
            };

        case type.UPDATE_SLOT_SUMMARY__FAILURE:
            return { ...state, error, requestState, status };

        case type.BLOCK_SLOT_SUMMARY__REQUEST:
            return { ...state, blockSlot: {}, requestState, status };

        case type.BLOCK_SLOT_SUMMARY__SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                blockSlot: action.result,
            };

        case type.BLOCK_SLOT_SUMMARY__FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_UNAVAILABILITY_REQUEST:
            return { ...state, unavailability: [], requestState, status };

        case type.GET_UNAVAILABILITY_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                unavailability: action.result,
            };

        case type.GET_UNAVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };

        case type.POST_UNAVAILABILITY_REQUEST:
            return { ...state, unavailabilityCreated: {}, requestState, status };

        case type.POST_UNAVAILABILITY_SUCCESS:
            unavailabilityCreated = action.result;
            return {
                ...state,
                unavailabilityCreated,
                requestState,
                status,
            };

        case type.POST_UNAVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };


        case type.DELETE_UNAVAILABILITY_REQUEST:
            return { ...state, unavailabilityDeleted: {}, requestState, status };

        case type.DELETE_UNAVAILABILITY_SUCCESS:
            unavailabilityDeleted = action.result;
            return {
                ...state,
                unavailabilityDeleted,
                requestState,
                status,
            };

        case type.DELETE_UNAVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_AVAILABILITY_REQUEST:
            return { ...state, availability: [], requestState, status };

        case type.GET_AVAILABILITY_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                availability: action.result,
            };

        case type.GET_AVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };

        case type.POST_AVAILABILITY_REQUEST:
            return { ...state, availabilityCreated: {}, requestState, status };

        case type.POST_AVAILABILITY_SUCCESS:
            availabilityCreated = action.result;
            return {
                ...state,
                availabilityCreated,
                requestState,
                status,
            };

        case type.POST_AVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };


        case type.UPDATE_AVAILABILITY_REQUEST:
            return { ...state, availabilityUpdated: {}, requestState, status };

        case type.UPDATE_AVAILABILITY_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                availabilityUpdated: action.result,
            };

        case type.UPDATE_AVAILABILITY_FAILURE:
            return { ...state, error, requestState, status };

        case type.MOVE_BULK_APPOINTEMNTS_REQUEST:
            return { ...state, bulk: {}, requestState, status };

        case type.MOVE_BULK_APPOINTEMNTS_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                bulk: action.result,
            };

        case type.MOVE_BULK_APPOINTEMNTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.UNBLOCK_SLOT_SUMMARY_REQUEST:
            return { ...state, unblock: {}, requestState, status };

        case type.UNBLOCK_SLOT_SUMMARY_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                unblock: action.result,
            };

        case type.UNBLOCK_SLOT_SUMMARY_FAILURE:
            return { ...state, error, requestState, status };

        case type.CANCEL_BULK_APPOINTMENTS_REQUEST:
            return { ...state, cancelBulkAppointment: {}, requestState, status };

        case type.CANCEL_BULK_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                cancelBulkAppointment: action.result,
            };

        case type.CANCEL_BULK_APPOINTMENTS_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_TIMELINE_REQUEST:
            return { ...state, timeline: [], requestState, status };

        case type.GET_TIMELINE_SUCCESS:
            return {
                ...state,
                requestState,
                status,
                error: null,
                timeline: action.result,
            };

        case type.GET_TIMELINE_FAILURE:
            return { ...state, error, requestState, status };


        default:
            return state;
    }
};
